"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleHeaderForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
/**
 * Simple form component for module header data.
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ModuleHeaderForm = class ModuleHeaderForm extends vue_property_decorator_1.Vue {
    updateText(value) {
        if (!this.header.intro) {
            this.header = {
                ...this.header,
                intro: {
                    text: value,
                    isBold: false
                }
            };
            return;
        }
        this.header.intro.text = value;
    }
    updateIsBold(value) {
        if (!this.header.intro) {
            this.header = {
                ...this.header,
                intro: {
                    text: '',
                    isBold: value
                }
            };
            return;
        }
        this.header.intro.isBold = value;
    }
};
__decorate([
    vue_property_decorator_1.PropSync('data', { type: Object, required: true }),
    __metadata("design:type", Object)
], ModuleHeaderForm.prototype, "header", void 0);
ModuleHeaderForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'ModuleHeaderForm',
        components: {
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea
        },
        template: `
    <div class="row">
      <div class="form-group col-12">
        <label for="small">{{ $t('forms.shared.headerSmall') }}</label>
        <DashmixInput :model.sync="header.small" name="small"
                      :placeholder="$t('forms.shared.headerPlaceholder')" />
      </div>

      <div class="form-group col-12">
        <label for="large">{{ $t('forms.shared.headerLarge') }}</label>
        <DashmixInput :model.sync="header.large" name="large"
                      :placeholder="$t('forms.shared.headerPlaceholder')" />
      </div>

      <div class="form-group col-12">
        <label for="intro">{{ $t('forms.shared.headerIntro') }}</label>
        <DashmixTextArea :model="header.intro ? header.intro.text : ''" name="intro_text" :rows="2"
                         @update:model="updateText"
                         :placeholder="$t('forms.shared.headerPlaceholder')" />
        <DashmixCheck :model="header.intro ? header.intro.isBold : false" name="intro_is_bold"
                      @update:model="updateIsBold"
                      :label="$t('forms.shared.isBold')" class="mt-1" />
      </div>
    </div>
  `
    })
], ModuleHeaderForm);
exports.ModuleHeaderForm = ModuleHeaderForm;
//# sourceMappingURL=ModuleHeader.form.js.map